import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "projects" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "grid-layout" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "head" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "bottom" }
const _hoisted_16 = { class: "langs" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "tags" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "screenshots" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, _toDisplayString(_ctx.$t('home.keyProjectsHeader')), 1),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainprojects, (project, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([`item-${i + 1}`, "item"]),
            key: i,
            onClick: ($event: any) => (_ctx.showModal(i))
          }, [
            _createElementVNode("img", {
              src: project.icon
            }, null, 8, _hoisted_5),
            _createElementVNode("div", {
              class: "name",
              innerHTML: project.title
            }, null, 8, _hoisted_6)
          ], 10, _hoisted_4))
        }), 128))
      ])
    ]),
    _createVNode(_component_Modal, { ref: "modal" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _ctx.mainprojects[_ctx.active].icon,
                alt: "Project Image"
              }, null, 8, _hoisted_10),
              _createElementVNode("div", {
                class: "name",
                innerHTML: _ctx.mainprojects[_ctx.active].title,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open(_ctx.mainprojects[_ctx.active].github)))
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                href: _ctx.mainprojects[_ctx.active].github,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "icon"
              }, [
                _createVNode(_component_ic, { icon: ['fab', 'github'] })
              ], 8, _hoisted_13)
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bar" }, null, -1)),
          _createElementVNode("div", {
            class: "desc",
            innerHTML: _ctx.mainprojects[_ctx.active].longdescription
          }, null, 8, _hoisted_14),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainprojects[_ctx.active].langs, (lang) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: lang,
                  class: "lang"
                }, [
                  _createElementVNode("div", {
                    class: "dot",
                    style: _normalizeStyle({ backgroundColor: _ctx.colors[lang] })
                  }, null, 4),
                  _createElementVNode("div", { innerHTML: lang }, null, 8, _hoisted_17)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainprojects[_ctx.active].tags, (tag, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tag",
                  key: index,
                  innerHTML: tag
                }, null, 8, _hoisted_19))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('projects.screenshots')), 1)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}